import { forwardRef } from 'react';

import type { ReactNode } from 'react';
import type React from 'react';

import type { ButtonProps } from './button';
import { Button } from './button';
import { Spinner } from './spinner';

const DEFAULT_SPINNER_SIZE = 16;

export type LoadingButtonProps = {
  isLoading?: boolean;
  loadingText?: string;
  children: ReactNode;
  disabled?: boolean;
} & Omit<ButtonProps, 'disabled' | 'children'>;

const LoadingButtonComponent = (
  {
    isLoading = false,
    loadingText,
    children,
    disabled = false,
    startIcon,
    ...buttonProps
  }: LoadingButtonProps,
  ref: React.Ref<HTMLButtonElement>
) => {
  const isDisabled = (disabled ?? false) || isLoading;
  const effectiveStartIcon = isLoading ? (
    <Spinner size={DEFAULT_SPINNER_SIZE} color='inherit' />
  ) : (
    startIcon
  );
  const label = isLoading && loadingText ? loadingText : children;

  return (
    <Button {...buttonProps} ref={ref} disabled={isDisabled} startIcon={effectiveStartIcon}>
      {label}
    </Button>
  );
};

LoadingButtonComponent.displayName = 'LoadingButton';

export const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>(
  LoadingButtonComponent
);
